module.exports = __webpack_public_path__ + "img/1.73646417.jpg";